import { FR } from './france';

export const GP = FR;
